/* DashLifestyle product sticky bar — delegates to Shopify's own product form */
(function(){
 function init(){
  document.querySelectorAll('[data-dash-sticky-pdp]').forEach(function(bar){
   if(bar.dataset.initialized==='1')return;
   bar.dataset.initialized='1';
   var id=bar.getAttribute('data-section-id');
   var button=bar.querySelector('[data-dash-sticky-button]');
   var priceLabel=bar.querySelector('[data-dash-sticky-price]');
   var comparePriceLabel=bar.querySelector('[data-dash-sticky-compare-price]');
   var section=document.getElementById('MainProduct-'+id);
   if(!section||!button)return;
   function getOriginal(){return document.getElementById('ProductSubmitButton-'+id)}
   function getPrice(){
    var el=document.getElementById('price-'+id);
    if(!el)return null;
    var sale=el.querySelector('.price--on-sale .price-item--sale');
    var normal=el.querySelector('.price__regular .price-item--regular');
    return (sale&&sale.textContent.trim())||(normal&&normal.textContent.trim())||null;
   }
   function getComparePrice(){
    var el=document.getElementById('price-'+id);
    if(!el)return null;
    var compare=el.querySelector('.price--on-sale .price__sale s.price-item--regular');
    return compare&&compare.textContent.trim()||null;
   }
   function sync(){
    var original=getOriginal();
    var available=!!original && !original.disabled;
    button.disabled=!available;
    if(original){
     var label=original.querySelector('span');
     var override=bar.getAttribute('data-dash-button-text');button.textContent=(available&&override)|| (label&&label.textContent.trim())|| (available?'Add to cart':'Unavailable');
    }
    var amount=getPrice();
    if(priceLabel&&amount)priceLabel.textContent=amount;
    if(comparePriceLabel){
     var compareAmount=getComparePrice();
     comparePriceLabel.hidden=!compareAmount;
     comparePriceLabel.textContent=compareAmount||'';
    }
   }
   function updateVisibility(){
    var original=getOriginal(),rect=original&&original.getBoundingClientRect(),area=section.getBoundingClientRect();
    var isShowingOriginal=rect&&rect.top<window.innerHeight-65&&rect.bottom>0;
    var isWithinProduct=area.bottom>100&&area.top<window.innerHeight;
    bar.dataset.visible=(!isShowingOriginal && isWithinProduct)?'true':'false';
   }
   function update(){sync();updateVisibility();}
   button.addEventListener('click',function(){
    var original=getOriginal();
    if(!original||original.disabled)return;
    original.click();
   });
   var scheduled=false;
   function rafUpdate(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;update();});}
   window.addEventListener('scroll',rafUpdate,{passive:true});
   window.addEventListener('resize',rafUpdate,{passive:true});
   var info=document.getElementById('ProductInfo-'+id);
   if(info){new MutationObserver(rafUpdate).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','class','aria-disabled']});}
   update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
